import { PopoverGroupOptionsMixin } from 'trunks/vue/admin/components/popover_group_options.js';

export default Vue.extend({
  mixins: [PopoverGroupOptionsMixin],

  template: `
    <popover-group-options optionsFilterPlaceholder='搜索状态'
                           :initialSelectedOptionIds='initialSelectedOptionIds'
                           :formatDataFunc='formatStatuses'
                           :needFilterInput='false'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='cancelFunc'
                           @submitClicked='submitFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='tip gray-text'>
          <i :class='option.icon'></i>
        </div>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <div class="list-group-name">没有相关的搜索结果</div>
      </div>
    </popover-group-options>
  `,

  props: {
    initialSelectedOptionIds: {
      type: Array,
    },
  },

  data() {
    return {
      tagGroups: [],
    };
  },

  methods: {
    formatStatuses() {
      return [{
        id: Skylark.Helpers.Utilities.uuid(),
        options: [
          { id: 'published', name: '已发布', icon: 'slp-paper-plane-o' },
          { id: 'drafted', name: '草稿箱', icon: 'slp-mail-box' },
          { id: 'closed', name: '已关闭', icon: 'slp-mail-reply' },
        ],
      }];
    },
  },
});
